import { Css, PageHeaderLayout, pageContentPaddingX } from "@homebound/beam";
import { useRouteParams } from "src/hooks/useRouteParams";
import { useDevelopmentContext } from "src/routes/developments/context/DevelopmentContext";
import { useTaskLookaheadQuery } from "src/routes/developments/reports/task-lookahead/TaskLookaheadPage.generated";
import { DevelopmentParams } from "src/routes/routesDef";
import { WeekRangeFilter } from "../WeekRangeFilter";
import { useWeekRangeFilter } from "../useWeekRangeFilter";
import { TaskLookaheadTable } from "./TaskLookaheadTable";

export const WEEKS_TO_SHOW = 8;

export function TaskLookaheadPage() {
  const { developmentId } = useRouteParams<DevelopmentParams>();
  const { name } = useDevelopmentContext();

  const rangeFilter = useWeekRangeFilter({ weekCount: WEEKS_TO_SHOW });
  const { includedWeekIntervals, dateRange } = rangeFilter;

  const query = useTaskLookaheadQuery({
    variables: { developmentId, searchIntervalEnd: dateRange.end, searchIntervalStart: dateRange.start },
  });

  return (
    <PageHeaderLayout pageHeader={{ title: "Task Lookahead", documentTitleSuffix: name }}>
      <div css={{ ...Css.layoutContainer.$, ...pageContentPaddingX }}>
        <WeekRangeFilter rangeFilter={rangeFilter} loading={query.loading} />
      </div>
      <TaskLookaheadTable query={query} includedWeekIntervals={includedWeekIntervals} developmentId={developmentId} />
    </PageHeaderLayout>
  );
}
